import { useEffect, useMemo, useState } from "react";
import { IHeaderTable } from "../../../../types/global";

export const useSalesItemListPdfHeader = () => {
  const [headers, setHeaders] = useState<IHeaderTable[]>([]);
  const columns = useMemo<IHeaderTable[]>(
    () => [
      {
        thaiLabel: "",
        width: 12,
      },
      {
        thaiLabel: "สินค้า",
        width: 122.2,
        align: "left",
      },
      {
        thaiLabel: "จำนวน",
        width: 112,
        align: "right",
      },
      {
        thaiLabel: "หน่วย",
        width: 56,
      },
    ],
    []
  );
  useEffect(() => {
    setHeaders(columns);
  }, [columns]);

  return headers;
};
